import { Component, Inject, OnInit } from '@angular/core';
import { MD_DIALOG_DATA } from '@angular/material';

@Component({
  selector: 'act-dialog-room-note-description',
  templateUrl: './dialog-room-note-description.component.html',
  styleUrls: ['./dialog-room-note-description.component.scss']
})
export class DialogRoomNoteDescriptionComponent implements OnInit {

  constructor(
    @Inject(MD_DIALOG_DATA) public data: string = ''
    ) { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/components/modal/dialog-room-note-description/dialog-room-note-description.component.ts